<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :width="width"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="order-assign-dialog"
    @close="handleClose"
  >
    <div class="dialog-content">
      <slot name="content">
        <p class="content-text">
          已选择 {{ orderCount }} 个水单，请选择要分配的帐号
        </p>
      </slot>
      <div class="selector-container">
        <as-emp-advanced-selector
          ref="empSelector"
          v-bind="$attrs"
          v-on="$listeners"
          @change="handleEmpChange"
        />
      </div>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import AsEmpAdvancedSelector from "@/components/emp-advanced-selector";

export default {
  name: "OrderAssignDialog",
  components: {
    AsEmpAdvancedSelector,
  },
  model: {
    prop: "visible",
    event: "update:visible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "水单分配",
    },
    width: {
      type: String,
      default: "500px",
    },
    orderCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedEmpList: [],
    };
  },
  methods: {
    handleEmpChange(empList, viewData) {
      this.selectedEmpList = empList;
    },
    handleClose() {
      this.$emit("close");
    },
    handleCancel() {
      this.$emit("cancel");
    },
    handleConfirm() {
      this.$emit("confirm", this.selectedEmpList);
    },
    reset() {
      this.selectedEmpList = [];
      if (this.$refs.empSelector && this.$refs.empSelector.clear) {
        this.$refs.empSelector.clear();
      }
    },
  },
};
</script>

<style lang="scss">
.order-assign-dialog {
  box-shadow: 0 0 15px 0 #00000054;
  border-radius: 6px;
  .dialog-content {
    .content-text {
      margin-bottom: 20px;
      font-size: 14px;
      color: #000000;
    }
    .selector-container {
      margin-bottom: 20px;
      .as-emp_advanced_selector,
      .mock-el-select_container,
      .as-selector {
        width: 100%;
      }
    }
  }
  .dialog-footer {
    text-align: right;
  }
}
</style>
